<template lang="pug">
.send-message-group-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // セル：種別
    template(#cell(type)="row")
      span(v-if="row.item.type == 0") 家族
      span(v-else) 施設関係者
    // セル：登録情報
    template(#cell(operation)="row")
      button.btn.edit-btn(@click="onEdit(row.item)") 修正
      button.btn.delete-btn(@click="onDelete(row.item)" type="button") 削除
    // セル：所属メンバー
    template(#cell(member)="row")
      .d-flex.flex-row.justify-content-center.align-items-center
        .member-count
          span {{ row.item.members.length }}人
        .member-detail.text-center(v-if="row.item.members.length == 0")
          button.btn.list-btn.disable(type="button" disabled) 一覧
          button.btn.edit-btn(v-if="_showControlButton" @click="onMemberEdit(row.item)" type="button") 変更
          button.btn.download-btn.disable(type="button" disabled) ダウンロード
        .member-detail.text-center(v-else)
          button.btn.list-btn(@click="onList(row.item)" type="button") 一覧
          button.btn.edit-btn(v-if="_showControlButton" @click="onMemberEdit(row.item)" type="button") 変更
          button.btn.download-btn(@click="onCsvDownload(row.item)" type="button") ダウンロード
</template>

<script lang="ts">
import { userStore } from "@/store/store";
import { GroupType } from "@/commons/services/SendMessageGroups";
import { Role } from "@/commons/services/Authorization";
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 宛先グループテーブルコンポーネント
 */
@Component({})
export default class SendMessageGroupTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<SendMessageGroupTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<SendMessageGroupTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<SendMessageGroupTableItem> {
    return this.value;
  }

  get _showControlButton(): boolean {
    return userStore.user.permissions.functions.sendMessageGroupsFunction;
  }

  /**
   * ### 修正ボタン押下イベント
   */
  public onEdit(group: SendMessageGroupTableItem): void {
    this.$emit("onEdit", group);
    return;
  }

  /**
   * ### 削除ボタン押下イベント
   */
  public onDelete(group: SendMessageGroupTableItem): void {
    this.$emit("onDelete", group);
    return;
  }

  /**
   * ### 一覧ボタン押下イベント
   */
  public onList(group: SendMessageGroupTableItem): void {
    this.$emit("onList", group);
    return;
  }

  /**
   * ### 変更ボタン押下イベント
   */
  public onMemberEdit(group: SendMessageGroupTableItem): void {
    this.$emit("onMemberEdit", group);
    return;
  }

  /**
   * ### CSVダウンロード
   */
  public onCsvDownload(group: SendMessageGroupTableItem): void {
    this.$emit("onCsvDownload", group);
    return;
  }

  /** 権限ロールを返却する */
  get getRole(): Role {
    return userStore.loginUser.role;
  }
}

/** テーブルの列名の情報 */
export interface SendMessageGroupTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface SendMessageGroupTableItem {
  id: number;
  type: GroupType;
  name: string;
  members: string[];
  updated: number;
}
</script>

<style lang="scss" scoped>
.send-message-group-table-component {
  .edit-btn,
  .delete-btn,
  .list-btn {
    width: 64px;
  }
  .operation {
    .edit-btn {
      margin-right: 12px;
    }
  }
  .list-btn,
  .edit-btn {
    margin-right: 12px;
  }

  .member-count {
    width: 80px;
  }
  .member-detail {
    width: calc(372px - 80px);
  }
}
</style>
